export default __webpack_public_path__ + "static/media/mask-group.570e96c2.png";